export function addPersistOrigin(origin) {
  return (dispatch) => {
    dispatch({
      type: "PERSISTORIGIN_SUCCESS",
      payload: origin,
    });
  };
}
